import type React from "react";
import type { ProfileDetailCTAProps } from "../../controllers/useProfileDetailController";
import { RequestIntroButton } from "./RequestIntroButton";
import { RequestedButton } from "./RequestedButton";
import { IgnoredButton } from "./IgnoredButton";
import { InboundRequestActions } from "./InboundRequestActions";
import { ConnectedActions } from "./ConnectedActions";

export type ProfileCTAProps = ProfileDetailCTAProps;

export function CTAContent(props: ProfileCTAProps): React.JSX.Element | null {
  switch (props.connectionStatus) {
    case "none":
      return (
        <RequestIntroButton
          onClick={props.onRequestIntro}
          isLoading={props.isLoading}
        />
      );

    case "requested":
      return <RequestedButton />;

    case "ignored":
      return <IgnoredButton />;

    case "inbound":
      return (
        <InboundRequestActions
          onAccept={props.onAccept}
          onIgnore={props.onIgnore}
          requestDate={props.requestDate}
          isLoading={props.isLoading}
        />
      );

    case "connected":
      return (
        <ConnectedActions
          onEmail={props.onEmail}
          onWhatsApp={props.onWhatsApp}
          connectedDate={props.connectedDate}
          hasEmail={props.hasEmail}
          hasPhone={props.hasPhone}
          isContactInfoPending={props.isContactInfoPending}
        />
      );

    default:
      return null;
  }
}

export function ProfileCTA(props: ProfileCTAProps): React.JSX.Element {
  return (
    <div className="fixed inset-x-0 bottom-0 border-t border-border bg-surface px-4 pb-4 pt-4">
      <CTAContent {...props} />
    </div>
  );
}
